import classnames from 'classnames';
import React from 'react';
import Phone from 'react-phone-number-input';
import ReactCountryFlag from 'react-country-flag';
import 'react-phone-number-input/rrui.css';
import 'react-phone-number-input/style.css';
import { CountryCode, isValidNumber } from 'libphonenumber-js';
import './PhoneInput.scss';

type Props = {
  className?: string;
  onChange: (phoneNumber: string, isValid: boolean) => any;
  onBlur?: (event) => any;
  country?: string | null;
  onFocus?: (event) => any;
  placeholder?: string;
  errorMessage?: string;
  errorState?: boolean;
  value?: string;
  name?: string;
  disabled?: boolean;
};

const FlagComponent = (props: { country: string }) => {
  const { country } = props;
  return <ReactCountryFlag svg countryCode={country} />;
};

const PhoneInput = (props: Props) => {
  const {
    className,
    onChange,
    onBlur,
    onFocus,
    placeholder,
    value = '',
    errorMessage,
    name,
    errorState,
    disabled,
    country,
  } = props;
  const countryToUse = (country || 'US') as CountryCode;

  const classList = classnames('phone-input', className, {
    'phone-input--error':
      errorState || (value && !isValidNumber(value, countryToUse)),
  });

  return (
    <div className={classList}>
      <Phone
        flagComponent={FlagComponent}
        disabled={disabled}
        smartCaret={false}
        country={countryToUse}
        onChange={phone => {
          onChange(phone, !!(phone && isValidNumber(phone, countryToUse)));
        }}
        onBlur={onBlur}
        onFocus={onFocus}
        placeholder={placeholder}
        value={value}
        error={errorMessage}
        name={name}
        indicateInvalid
      />
    </div>
  );
};

const ReduxFormPhoneInput = props => {
  const { input, placeholder, className, meta, ...rest } = props;
  const { onChange, onBlur, onFocus, value } = input;
  const { touched, active, error } = meta;

  const errorMessage = touched && !active ? error : null;

  return (
    <PhoneInput
      flagComponent={FlagComponent}
      placeholder={placeholder}
      className={className}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      value={value}
      errorMessage={errorMessage}
      {...rest}
    />
  );
};

export { PhoneInput, ReduxFormPhoneInput };
